import { gql } from '@apollo/client';

export const DELETE_ARBEITSBEREICH_STATION = gql`
  mutation mitarbeiter_deleteArbeitsbereichStation(
    $arbeitsbereichStationId: String!
    $fristId: String
  ) {
    mitarbeiter_deleteArbeitsbereichStation(
      arbeitsbereichStationId: $arbeitsbereichStationId
      fristId: $fristId
    ) {
      success {
        arbeitsbereichStationId
        details
        fristResult {
          error {
            message
          }
          success
        }
      }
      error {
        message
      }
    }
  }
`;
